import { Type, plainToClass } from 'class-transformer';

import { IViewModel } from '../../interfaces/view-model.interface';
import { TargetFieldConditionalLogicInstructions } from './target-field-logic-instructions';

export class SiteHomePageLoadedConditionalLogicInstructions implements IViewModel {
    public id: number = 0; // An unused Id used to make the class conform to interface IViewModel.

    public dataCollectionId: number;
    public contentTemplateId: number;   

    @Type(() => TargetFieldConditionalLogicInstructions)
    public targetFieldInstructions: TargetFieldConditionalLogicInstructions[];
}
